/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useState } from 'react';
import './index.css';
import './about.css';
import Navbar from "./Components/navbar";
import Feedback from "./Components/Feedback";
import Footer from "./Components/footer";
import Group1 from '../assets/Group1.png';
import LinkedIn from '../assets/linkedin.png';
import Mask1 from '../assets/Fr1.png';
import Mask2 from '../assets/Fr.png';
// import { getAllContents, getTeamMembers } from '../services/content.service';
import LanguageContext from '../context/LanguageContext';
import { useLoader } from '../context/LoaderContext';


const Meet = () => {
    const [selectedDoctor, setSelectedDoctor] = useState(null);
    // const [doctors, setDoctors] = useState([]);
    const { selectedLanguage } = useContext(LanguageContext);
    // const [contents, setContents] = useState();

    const { appData } = useLoader();
    const { contents, teamMembers } = appData;

    const directors = [
        { id: 1, image: contents?.data.doct_img_1.image, name: contents?.data.director_1.content_fr, title_fr: contents?.data.director_1_title.content_fr, title_en: contents?.data.director_1_title.content_en },
        // { id: 2, image: contents?.data.doct_img_2.image, name: contents?.data.director_2.content_fr, title_fr: contents?.data.director_2_title.content_fr, title_en: contents?.data.director_2_title.content_en },
    ];

    // Get contents on component mount
    // useEffect(() => {
    //     const fetchContents = async () => {
    //         try {
    //             const response = await getAllContents();
    //             setContents(response.data);
    //             setDoctors(await getTeamMembers())
    //         } catch (error) {
    //             console.error('Failed to fetch contents:', error.message || error);
    //         }
    //     };
    //     fetchContents();
    // }, []);

    const scrollToSection = (sectionId) => {
        setTimeout(() => {
            const element = document.getElementById(sectionId);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }, 300); // Délai de 300 ms
    };

    return (
        <div className="container-fluid" style={{ paddingLeft: '0px', paddingRight: '0px' }}>
            <div><Navbar /></div>
            <section className="mt-4 position-relative" style={{ backgroundColor: '#17416F', padding: '100px 0' }}>
                <h1 className="text-center text-white" style={{ textTransform: 'uppercase', fontWeight: '700', fontSize: '40px' }}>
                    {selectedLanguage === 'fr' ? contents?.data.team_page_title.content_fr : contents?.data.team_page_title.content_en}
                </h1>
                <div className="position-absolute bottom-0 start-0">
                    <img src={Group1} alt="" />
                </div>
                <div className="position-absolute top-0 end-0">
                    <img src={Mask1} alt="" />
                </div>
            </section>
            <br /><br /><br />
            <section className="container mt-4">
                <div className="row">
                    <div className="col-md-2 mx-auto mb-3">
                        <h2 className='text-center' style={{ color: '#17416F', textTransform: 'uppercase', fontWeight: 700, fontSize: '30px' }}>
                            {selectedLanguage === 'fr' ? contents?.data.team_page_team_title.content_fr : contents?.data.team_page_team_title.content_en}
                        </h2>
                    </div>
                    <div className="col-md-8 mx-auto">
                        <div style={{ color: '#17416F' }}>
                            {selectedLanguage === 'fr' ? (<div dangerouslySetInnerHTML={{
                                __html: contents?.data.team_descp.content_fr
                            }} />) : (<div dangerouslySetInnerHTML={{
                                __html: contents?.data.team_descp.content_en
                            }} />)}
                        </div>
                    </div>
                </div>
            </section>
            <br /><br /><br />
            <section className="container my-4" style={{ backgroundColor: "#13AB9C", padding: "40px 0px" }}>
                <h2 className="text-center" style={{ color: "white", fontWeight: 700, textTransform: "uppercase", fontSize: 'clamp(25px, 8vw, 36px)' }}>
                    {selectedLanguage === 'fr' ? contents?.data.team_page_directors.content_fr : contents?.data.team_page_directors.content_en}
                </h2>
                <br />
                <div className="row justify-content-center">
                    <div className="col-lg-2"></div>
                    {directors.map((director) => (
                        <div key={director.id} className="col-lg-4 mx-auto mb-md-0 mb-3">
                            <div className="p-3">
                                <img src={director.image} alt={director.name} className="img-fluid w-100" style={{ maxHeight: '80vh', objectFit: 'cover' }} />
                                <h4 className="text-center mt-4" style={{ color: "white", fontWeight: 700, textTransform: "uppercase", fontSize: 'clamp(18px, 8vw, 24px)' }}>
                                    {director.name}
                                </h4>
                                <p className="text-white text-center mt-3" style={{ fontSize: 'clamp(16px, 8vw, 20px)' }}>{selectedLanguage === 'fr' ? director.title_fr : director.title_en}</p>
                                <span className="d-block mt-4" style={{ borderBottom: ".3px solid white" }}></span>
                            </div>
                        </div>
                    ))}
                    <div className="col-lg-2"></div>

                </div>
            </section>
            <br /><br /><br />
            <section className="container">
                <h2 className="text-center" style={{ color: "#17416F", textTransform: "uppercase", fontWeight: 700, fontSize: '36px' }}>
                    {selectedLanguage === 'fr' ? contents?.data.team_page_doctors_title.content_fr : contents?.data.team_page_doctors_title.content_en}
                </h2>
                <br />
                <div className="row mt-4">
                    {teamMembers.map((doctor) => (
                        <div key={doctor.id} className="col-12 col-md-6 col-lg-3 mb-4 dot">
                            <a href="#" onClick={(e) => { e.preventDefault(); setSelectedDoctor(doctor); }}>
                                <img src={doctor.photo} alt={doctor.nom} className="img-fluid w-100 doto" style={{ borderTopRightRadius: "30px", height: "50vh", objectFit: "cover" }} />
                            </a>
                            <h3 className="text-center mt-3" style={{ color: "#17416F", fontWeight: 700, textTransform: "uppercase", fontSize: 'clamp(18px, 8vw, 25px)' }}>
                                {doctor.nom} {doctor.prenom}
                            </h3>
                            <p className="text-center mt-3" style={{ color: "#13AB9C", fontSize: 'clamp(16px, 8vw, 20px)' }}>{doctor.titre}</p>

                            <span className="d-block mt-3" style={{ borderBottom: "1px solid #17416F33" }}></span>
                        </div>
                    ))}
                </div>

                {/* Modal */}
                {selectedDoctor && (
                    <div className="modal fade show d-block" tabIndex="-1">
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-body position-relative">
                                    <div className='d-flex'>
                                        <div className='color1'>
                                            <div className="row">
                                                <div className="col-12 col-lg-5 mx-auto mb-4">
                                                    <div className="position-relative">
                                                        <img src={selectedDoctor.photo} alt={selectedDoctor.nom} className="img-fluid w-100" style={{ borderTopRightRadius: "30px" }} />
                                                        <div className="poop">
                                                            <a href="#"><img src={LinkedIn} alt="LinkedIn" /></a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12 col-lg-7 mx-auto mb-4">
                                                    <h2 style={{ fontSize: "25px", color: "#17416F", fontWeight: 800 }}>{selectedDoctor.nom} {selectedDoctor.prenom}</h2>
                                                    <p style={{ color: "#13AB9C", fontWeight: '600' }}>{selectedLanguage === 'fr' ? selectedDoctor.titre : selectedDoctor.titre_en}</p>
                                                    <span className="my-4 d-block" style={{ borderBottom: "1px solid #17416F33" }}></span>
                                                    <div style={{ color: "#17416F" }}>
                                                        {selectedLanguage === 'fr' ? (<div dangerouslySetInnerHTML={{
                                                            __html: selectedDoctor.description
                                                        }} />) : (<div dangerouslySetInnerHTML={{
                                                            __html: selectedDoctor.description_en
                                                        }} />)}
                                                        {/* {selectedLanguage === 'fr' ? contents?.data.modal_descp.content_fr : contents?.data.modal_descp.content_en} */}
                                                    </div>
                                                    <div className="mt-3">
                                                        <button className="btn btn-cont px-4 py-2" style={{ color: "white", backgroundColor: "#13AB9C" }}>
                                                            {selectedLanguage === 'fr' ? contents?.data.modal_button.content_fr : contents?.data.modal_button.content_en}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col">
                                            <button onClick={() => setSelectedDoctor(null)} className="btn-cl fs-3 text-white">
                                                <i class="bi bi-x-lg"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {selectedDoctor && <div className="modal-backdrop fade show" onClick={() => setSelectedDoctor(null)}></div>}
            </section>
            <br /><br /><br />
            <section className="container">
                <div className="row">
                    <div className="col-12 col-md-5 mx-auto mb-3 mb-md-0">
                        <div className='position-relative'>
                            <img src={contents?.data.team_page_staff_img.image} alt="Staff Members" className="img-fluid w-100 main-img1" style={{ objectFit: 'cover', borderTopRightRadius: '30px' }} />
                            <div className='contpos'>
                                <img src={Mask2} alt="Staff Members" className="img-fluid" />
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 mx-auto mb-3 mb-md-0 p-5 align-self-center">
                        <h2 style={{ textTransform: "uppercase", color: "#17416F", fontWeight: '700', fontSize: 'clamp(25px, 8vw, 36px)' }}> {selectedLanguage === 'fr' ? contents?.data.team_page_staff_title.content_fr : contents?.data.team_page_staff_title.content_en}</h2>
                        <p className="mt-3" style={{ color: "#17416F" }}>
                            {selectedLanguage === 'fr' ? contents?.data.team_page_staff_desc.content_fr : contents?.data.team_page_staff_desc.content_en}
                        </p>
                        <div className="mt-3">
                            <button className="btn btn-cont text-white px-4" style={{ backgroundColor: "#13AB9C" }} onClick={() => scrollToSection("feedback-section")}>
                                {selectedLanguage === 'fr' ? contents?.data.team_page_staff_button.content_fr : contents?.data.team_page_staff_button.content_en}
                            </button>
                        </div>
                    </div>
                </div>
            </section>
            <div id='feedback-section'>
                <Feedback />
            </div>
            <div>
                <Footer />
            </div>
        </div>
    );
};

export default Meet;
